<template>
  <div class="app-container">
    <el-form ref="queryForm" :model="queryParams" size="small" :inline="true">
      <el-form-item>
        <!--        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
                <el-button type="success" icon="el-icon-edit" :disabled="single" @click="handleUpdate">修改</el-button>-->
        <el-button type="danger" icon="el-icon-delete" :disabled="multiple" @click="handleDelete">删除</el-button>
      </el-form-item>
      <el-form-item label="用户昵称" prop="name">
        <el-input
          v-model="queryParams.nickname"
          placeholder="用户昵称内容"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="机票数量" prop="num">
        <el-input
          type="number"
          v-model="queryParams.num"
          placeholder="机票数量"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="支付价格" prop="payNum">
        <el-input
          v-model="queryParams.payNum"
          placeholder="支付价格"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="支付渠道" prop="payType">
        <el-select v-model="queryParams.payType" placeholder="请选择支付渠道">
          <el-option label="微信" value="2"></el-option>
          <el-option label="支付宝" value="1"></el-option>
          <el-option label="苹果" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间段" prop="url">
        <el-date-picker
          v-model="selectDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          placeholder="请选择"
          @change="dateChange"
          value-format="yyyy-MM-dd HH:mm:ss"
          @keyup.enter.native="handleQuery">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="handleResetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="pageList" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="序号" type="index" width="100" />
      <el-table-column label="用户昵称" prop="nickname" :show-overflow-tooltip="true" width="100" />
      <el-table-column label="机票数量" prop="num" :show-overflow-tooltip="true" width="250" />
      <el-table-column label="支付价格" prop="payNum" :show-overflow-tooltip="true" width="100"/>
      <el-table-column label="支付渠道" prop="payType" :formatter="payTypeFormat" :show-overflow-tooltip="true" width="250" />
      <el-table-column label="创建时间" prop="createTime" :show-overflow-tooltip="true" />
      <el-table-column label="操作" align="center" width="200" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <!--          <el-button
                      type="text"
                      icon="el-icon-edit"
                      @click="handleUpdate(scope.row)"
                    >修改
                    </el-button>-->
          <el-button
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="pagination.total>0"
      :total="pagination.total"
      :page.sync="pagination.current"
      :limit.sync="pagination.size"
      @pagination="handleQuery"
    />

    <!-- 添加或修改充值配置对话框 -->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="600px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="用户昵称" prop="num">
          <el-input v-model="form.nickname" placeholder="请输入用户昵称" />
        </el-form-item>
        <el-form-item label="机票数量" prop="num">
          <el-input v-model="form.num" placeholder="请输入vip时长" />
        </el-form-item>
        <el-form-item label="支付价格" prop="num">
          <el-input v-model="form.payNum" placeholder="请输入支付价格" />
        </el-form-item>
        <el-form-item label="支付渠道" prop="num">
          <el-input v-model="form.payType" placeholder="请输入支付渠道" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialog.visible=false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { list, detail, update, add, del ,getVipList} from '@/api/finance/userbuy'

export default {
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      selectDate:"",
      queryParams: {
        name: undefined,
        type: 1,
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      pageList: [],
      dialog: {
        title: undefined,
        visible: false
      },
      // 菜单列表
      menuOptions: [],
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        num: [
          { required: true, message: '充值内容不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    dateChange(){
      if (this.selectDate){
        this.queryParams.startTime = this.selectDate[0]
        this.queryParams.endTime = this.selectDate[1]
      }
    },
    appTypeFormat(row) {
      return row.appType === 1 ? '苹果' : '安卓'
    },
    statusFormat(row) {
      return row.status === 1 ? '禁用' : '使用中'
    },
    payTypeFormat(row){
      if (row.payType===1){
        return '支付宝'
      }
      if (row.payType===2){
        return '微信'
      }
      if (row.payType===3){
        return '苹果'
      }
    },
    handleQuery() {
      this.queryParams.current = this.pagination.current
      this.queryParams.size = this.pagination.size
      this.queryParams.type = 2
      getVipList(this.queryParams).then(response => {
        this.pageList = response.data.records
        this.pagination.total = response.data.total
        this.loading = false
      })
    },
    handleResetQuery() {
      this.pagination = {
        current: 1,
        size: 10,
        total: 0
      }
      this.queryParams = {}
      this.selectDate=[]
      this.handleQuery()
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length != 1
      this.multiple = !selection.length
    },
    handleStatusChange(row) {
      const text = row.status === 1 ? '启用' : '停用'
      this.$confirm('确认要"' + text + row.name + '"数据项吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        return patch(row.id, { status: row.status })
      }).then(() => {
        this.$message.success(text + '成功')
      }).catch(function() {
        row.status = row.status === 1 ? 0 : 1
      })
    },
    handleAdd() {
      this.resetForm()
      this.dialog = {
        title: '新增充值',
        visible: true
      }
    },
    handleUpdate(row) {
      this.resetForm()
      this.dialog = {
        title: '修改充值',
        visible: true
      }
      const id = row.id || this.ids
      detail(id).then(response => {
        this.form = response.data
      })
    },
    handleDelete(row) {
      const ids = [row.id || this.ids].join(',')
      console.log(this.ids)
      this.$confirm('是否确认删除选中的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        del(ids).then(() => {
          this.$message.success('删除成功')
          this.handleQuery()
        })
      }).catch(() =>
        this.$message.info('已取消删除')
      )
    },
    handleSubmit: function() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const id = this.form.id
          if (id != undefined) {
            update(this.form.id, this.form).then(() => {
              this.$message.success('修改成功')
              this.dialog.visible = false
              this.handleQuery()
            })
          } else {
            add(this.form).then(() => {
              this.$message.success('新增成功')
              this.dialog.visible = false
              this.handleQuery()
            })
          }
        }
      })
    },
    resetForm() {
      this.form = {
        id: undefined,
        name: undefined,
        url: undefined
      }
      if (this.$refs['form']) {
        this.$refs['form'].resetFields()
      }
    }
  }
}
</script>
